export const prismicClientDocsUrl =
  "https://prismic.io/docs/technical-reference/prismicio-client"
